<template>
  <page-error
    class="v-error503"
    :buttonRedirect="''"
    :buttonText="$t('Refresh page')"
    :code="503"
    :message="$t('The admin panel is temporarily unavailable. Please try again in a few minutes.')"
    :title="$t('Service unavailable')"
  />
</template>

<script>
  import PageError from '@/common/components/PageError.vue';

  export default {
    name: 'Error503',
    components: {
      PageError
    }
  };
</script>
